class GainNode extends Weaver.Node

  @className = 'GainNode'

  constructor: (id) ->
    super(id)

  create: (name = "New Gain") ->
    type = await Weaver.Node.firstOrCreate('Gain')
    @set('name', name)
    @set('gain', 0.25)
    @relation('type').add(type)
    @save()

export default GainNode
